import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-161d5b80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-menu d-flex flex-col flex-no-wrap h-100 overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Video")
const _hoisted_3 = {
  key: 0,
  class: "video-overlay"
}
const _hoisted_4 = { class: "event-spinner-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitingRoomOverlay = _resolveComponent("WaitingRoomOverlay")!
  const _component_OnDemandBookingTelehealthWaitingRoomOverlay = _resolveComponent("OnDemandBookingTelehealthWaitingRoomOverlay")!
  const _component_app_chip = _resolveComponent("app-chip")!
  const _component_PatientTelehealthHeader = _resolveComponent("PatientTelehealthHeader")!
  const _component_ChatView = _resolveComponent("ChatView")!
  const _component_EventStateSpinner = _resolveComponent("EventStateSpinner")!
  const _component_VideoViewForIonSlides = _resolveComponent("VideoViewForIonSlides")!
  const _component_TelehealthWrapper = _resolveComponent("TelehealthWrapper")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.shouldShowOverlay && _ctx.isRegularTelehealth)
        ? (_openBlock(), _createBlock(_component_WaitingRoomOverlay, {
            key: 0,
            onExit: _ctx.onExit,
            isLoading: !_ctx.callOver
          }, null, 8, ["onExit", "isLoading"]))
        : (_ctx.shouldShowOverlay && _ctx.isAqsTelehealth)
          ? (_openBlock(), _createBlock(_component_OnDemandBookingTelehealthWaitingRoomOverlay, {
              key: 1,
              onExit: _ctx.onExit,
              "clinic-id": _ctx.clinicId,
              "queue-id": _ctx.queueId,
              "queued-appointment-id": _ctx.queuedAppointmentId,
              isLoading: !_ctx.callOver
            }, null, 8, ["onExit", "clinic-id", "queue-id", "queued-appointment-id", "isLoading"]))
          : _createCommentVNode("", true),
      _createVNode(_component_TelehealthWrapper, {
        "chat-visible": _ctx.chatVisible,
        "onUpdate:chat-visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chatVisible) = $event)),
        "content-id": "video-view"
      }, {
        menu: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_PatientTelehealthHeader, { onExit: _ctx.onExit }, {
              default: _withCtx(() => [
                (_ctx.inRoom())
                  ? (_openBlock(), _createBlock(_component_app_chip, {
                      key: 0,
                      id: "chat-toggle",
                      onClick: _ctx.toggleChat,
                      onExit: _cache[0] || (_cache[0] = ($event: any) => {_ctx.onExit();})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onExit"]),
            _createVNode(_component_ChatView, {
              class: "flex-item-grow m-l-16 m-r-16",
              onSend: _ctx.sendTextMessage,
              onSendFile: _ctx.sendDocumentMessage,
              onInput: _ctx.singleTyping,
              typing: _ctx.showTypingIndication,
              "chat-items": _ctx.chatItems,
              disabled: !_ctx.remoteConnected()
            }, null, 8, ["onSend", "onSendFile", "onInput", "typing", "chat-items", "disabled"])
          ])
        ]),
        content: _withCtx(() => [
          _createVNode(_component_VideoViewForIonSlides, {
            onCall: _ctx.enterRoom,
            onEnd: _ctx.endCall,
            onFlip: _ctx.cycleCamera,
            onToggleVideo: _ctx.toggleVideo,
            onMute: _ctx.toggleMute,
            onChat: _ctx.toggleChat,
            state: _ctx.videoControlState
          }, {
            default: _withCtx(() => [
              (!_ctx.doctorConnected() && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_EventStateSpinner, {
                        textColorLight: "",
                        isLoading: true,
                        loadingIcon: "icon-tele-doc",
                        loadingTitle: this.$mhat('TelehealthPatient.DoctorHasLeftTitle'),
                        loadingMessage: this.$mhat('TelehealthPatient.DoctorHasLeftMessage'),
                        failureIcon: "icon-clinic"
                      }, null, 8, ["loadingTitle", "loadingMessage"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onCall", "onEnd", "onFlip", "onToggleVideo", "onMute", "onChat", "state"])
        ]),
        _: 1
      }, 8, ["chat-visible"])
    ]),
    _: 1
  }))
}